import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["canSubmit"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EscalationPanelFooter(_ref) {
  let {
      canSubmit = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const props = Object.assign({
    canSubmit
  }, rest);
  return /*#__PURE__*/_jsxs(PanelFooter, {
    padding: "600",
    children: [/*#__PURE__*/_jsx(Button, {
      "data-test-id": "escalation-panel-footer-submit-button",
      disabled: !props.canSubmit,
      onClick: props.onSubmit,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.panel.footer.submit"
      })
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "escalation-panel-footer-cancel-button",
      onClick: props.onCancel,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.panel.footer.cancel"
      })
    })]
  });
}
EscalationPanelFooter.propTypes = {
  canSubmit: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
export default EscalationPanelFooter;